exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Ar_sLIJIhNIXkmcclIZI7{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:3.92857rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;padding:0;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.Ar_sLIJIhNIXkmcclIZI7{padding-left:2.14286rem;padding-right:2.14286rem}}.Ar_sLIJIhNIXkmcclIZI7 button{overflow:hidden;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavBig": "Ar_sLIJIhNIXkmcclIZI7"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./components/ViewNav/ViewNavBig/style.postcss
// module id = 1412
// module chunks = 0